<!--File Upload Starts-->
<section id="file-upload">
  <div class="row text-left">
    <div class="col-sm-12">
      <div class="content-header">Angular2 File Upload</div>
    </div>
  </div>
  <div class="card text-left">
    <div class="card-header">
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)"
            [uploader]="uploader" class="py-5 mb-3 text-center font-medium-5 text-uppercase grey my-drop-zone">
            Base dropzone
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div ng2FileDrop [ngClass]="{'another-file-over-class': hasAnotherDropZoneOver}"
            (fileOver)="fileOverAnother($event)" [uploader]="uploader"
            class="py-5 mb-3 text-center font-medium-5 text-uppercase grey my-drop-zone">
            Another dropzone
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3">
          <h4>Select files</h4>
          <div>Multiple</div>
          <label class="custom-file mb-3">
            <input type="file" ng2FileSelect [uploader]="uploader" multiple>
            <span class="custom-file-control"></span>
          </label>

          <div>Single</div>
          <label class="custom-file">
            <input type="file" ng2FileSelect [uploader]="uploader">
            <span class="custom-file-control"></span>
          </label>
        </div>

        <div class="col-lg-9">
          <h4>Upload queue</h4>
          <p>Queue length: {{ uploader?.queue?.length }}</p>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th width="50%">Name</th>
                  <th>Size</th>
                  <th>Progress</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of uploader.queue">
                  <td><strong>{{ item?.file?.name }}</strong></td>
                  <td *ngIf="uploader.isHTML5" nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                  <td *ngIf="uploader.isHTML5">
                    <div class="progress" style="margin-bottom: 0;">
                      <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                    </div>
                  </td>
                  <td class="text-center">
                    <span *ngIf="item.isSuccess"><i class="fa fa-ok"></i></span>
                    <span *ngIf="item.isCancel"><i class="fa fa-ban"></i></span>
                    <span *ngIf="item.isError"><i class="fa fa-remove"></i></span>
                  </td>
                  <td nowrap>
                    <button type="button" class="btn btn-success btn-sm mr-1" (click)="item.upload()"
                      [disabled]="item.isReady || item.isUploading || item.isSuccess">
                      <span class="fa fa-upload"></span> Upload
                    </button>
                    <button type="button" class="btn btn-warning btn-sm mr-1" (click)="item.cancel()"
                      [disabled]="!item.isUploading">
                      <span class="fa fa-ban"></span> Cancel
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" (click)="item.remove()">
                      <span class="fa fa-trash"></span> Remove
                    </button>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div>
            <p>Queue progress:
              <ngb-progressbar type="primary" [value]="uploader.progress"></ngb-progressbar>
            </p>
            <button type="button" class="btn btn-success mr-1 mb-1 mb-sm-0" (click)="uploader.uploadAll()"
              [disabled]="!uploader.getNotUploadedItems().length">
              <span class="fa fa-upload"></span> Upload all
            </button>
            <button type="button" class="btn btn-warning mr-1 mb-1 mb-sm-0" (click)="uploader.cancelAll()"
              [disabled]="!uploader.isUploading">
              <span class="fa fa-ban"></span> Cancel all
            </button>
            <button type="button" class="btn btn-danger mb-1 mb-sm-0" (click)="uploader.clearQueue()"
              [disabled]="!uploader.queue.length">
              <span class="fa fa-trash"></span> Remove all
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--File Upload Ends-->
